<template>
    <div class="card">
        <div class="card-header pb-0">
            <div class="row align-top">
                <div class="col-md-2">
                    <h6>Productos</h6>
                </div>
                <div class="col-md-8">
                    <div class="input-group">
                        <span class="input-group-text text-body">
                        <i class="fas fa-search" aria-hidden="true"></i>
                        </span>
                        <input
                        type="text"
                        class="form-control"
                        v-model="searchTerm"
                        :placeholder="
                            this.$store.state.isRTL ? 'أكتب هنا...' : 'Buscar...'
                        "
                        />
                    </div>
                </div>
                <div class="col-md-2 ">
                    <argon-button
                    class="mt-0"
                    color="success"
                    fullWidth
                    size="xs"
                    @click="toCreate"
                    >Agregar Nuevo</argon-button>
                </div>
            </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >SKU</th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Producto</th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Descripción</th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >P. Compra</th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >P. Venta</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Acciones
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(
                            {
                                id,
                                sku,
                                name,
                                description,
                                price,
                                sale_price
                            },
                            index
                            ) in filteredRows"
                            :key="index"
                        >
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-sm">{{ sku }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div>

                                    </div>
                                    <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-sm">{{name}}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0 text-end">{{ description }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0 text-end">{{  $formatCurrency(price,currency,symbol) }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0 text-end">{{ $formatCurrency(sale_price,currency,symbol) }}</p>
                            </td>
                            <td class="align-middle">
                                <a
                                    :href="'products/'+id"
                                    class="btn bg-success mx-2"
                                    data-toggle="tooltip"
                                    data-original-title="Ver producto"
                                ><i class="fa fa-pen text-white text-sm opacity-10"></i></a>
                                <a
                                    @click="deleteProduct(id)"
                                    class="btn bg-danger mx-2"
                                    data-toggle="tooltip"
                                    data-original-title="Eliminar producto"
                                ><i class="fa fa-trash text-white text-sm opacity-10"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { useCompanyConfig } from '@/composables/useCompanyConfig';
import axios from "axios";
export default {
    name: "patients-table",
    props: {
        clients:Array,
    },
    data(){
        return({
            searchTerm:null,
            clientsList: [],
            currency:'USD',
            symbol:'$'
        })
    },
    components: { ArgonButton },
    setup(){
        const { companyConfig,isLoadingCiaConfig, fetchCompanyConfig } = useCompanyConfig();
        // Cargar la configuración cada vez que el componente se monte/cargue
        fetchCompanyConfig();
        return { companyConfig ,isLoadingCiaConfig};
    },
    computed:{
        filteredRows(){
            if(!this.searchTerm){
                return this.clients;
            }else{
                return this.clients.filter(item => {
                    let firstName=item.name.toString().toLowerCase();
                    let documentNat=item.code.toString().toLowerCase();
                    return firstName.includes(this.searchTerm)||documentNat.includes(this.searchTerm)
                })
            }
        }
    },
    watch:{
        companyConfig(newVal){
            this.currency=newVal.currency_code;
            this.symbol=newVal.currency_symbol;
        },
    },
    methods:{
        toCreate(){
            this.$router.push('/products/create')
        },
        deleteProduct(ProductId){
            const token = localStorage.getItem("accessToken");
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': '*/*',
                    'Authorization': `Bearer ${token}`
                }
            };
            this.$swal({
                title: '¿Estás seguro de eliminar este producto?',
                text: '¡Esta acción no se puede deshacer!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33', // Rojo para confirmar eliminación
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(this.$store.state.apiURL + 'products/'+ProductId, config)
                    .then(() => {
                        this.$swal({
                            title: 'Producto eliminado',
                            text: 'El producto fue registrado correctamente.',
                            icon: 'success',
                            confirmButtonColor: '#0b9257'
                        }).then(() => {
                            this.$emit('producto-eliminado');
                        });
                    })
                    .catch((error) => {
                        console.error('Error al eliminar producto:', error);
                        this.$swal({
                            title: 'Error',
                            text: 'No se pudo eliminar el producto. Revise el token o la conexión.',
                            icon: 'error',
                            confirmButtonColor: '#d33'
                        });
                    });
                }
            })

        },
    },
};
</script>
